<template>
  <div class="swiper-wrap row no-gutters ml-n2 md:ml-n3 lg:mt-n3 xl:ml-n4 xl:mt-n4">
    <!-- Mobile -->
    <div
      v-if="BrowserService.isTablet()"
      class="row mx-0 w-100 mb-0 flex-grow-1 h-auto mb-0 list-unstyled"
    >
      <Swiper
        v-if="ingredients.length > 0"
        class="mixes-carousel row mx-0 w-100 mb-0 flex-grow-1 h-auto mb-0 list-unstyled"
        slides-per-view="auto"
        :modules="[Scrollbar]"
        :on-init="onSwiperInit"
        :scrollbar="{ draggable: true, hide: false }"
        @swiper="onSwiper"
      >
        <SwiperSlide
          v-for="ingredient in ingredients"
          :key="ingredient.id"
          class="col-6 sm:col-5 md:col-4 flex flex-col pl-2 md:pl-3 lg:pt-3 xl:pl-4 xl:pt-4"
        >
          <MixesGridIngredient
            :kind="kind"
            :ingredient="ingredient"
          />
        </SwiperSlide>
      </Swiper>
      <BaseLoading
        v-else
        :style="{ minHeight: '240px' }"
      />
      <!-- Carousel arrows -->
      <div class="absolute position-center left-0 mt-4 md:mt-6 xl:pt-9 pt-8 ml-1 md:ml-n3 zindex-11">
        <ButtonChevron
          direction="l"
          class="btn-warning text-primary p-2"
          data-slide="prev"
          aria-label="Previous slide"
          @click="() => { mixesSwiper.slidePrev() }"
        />
      </div>
      <div class="absolute position-center right-0 mt-4 md:mt-6 xl:pt-9 pt-8 mr-1 md:mr-n3 zindex-11">
        <ButtonChevron
          direction="r"
          class="btn-warning text-primary p-2"
          data-slide="next"
          aria-label="Next slide"
          @click="() => { mixesSwiper.slideNext() }"
        />
      </div>
    </div>
    <!-- Desktop -->
    <div v-else class="row mx-0 w-100 mb-0 flex-grow-1 h-auto mb-0 list-unstyled">
      <ul
        v-if="ingredients.length > 0"
        class="mixes-catalog__grid row mx-0 w-100 mb-0 flex-nowrap lg:flex-wrap flex-grow-1 h-auto no-gutters mb-0 list-unstyled"
      >
        <li
          v-for="ingredient in ingredients"
          :key="ingredient.id"
          class="col-6 sm:col-5 md:col-4 flex flex-col pl-2 md:pl-3 lg:pt-3 xl:pl-4 xl:pt-4"
        >
          <MixesGridIngredient
            :kind="kind"
            :ingredient="ingredient"
          />
        </li>
      </ul>
      <BaseLoading
        v-else
        :style="{ minHeight: '350px' }"
      />
    </div>
  </div>
</template>

<script setup>
import { noop } from '@vueuse/core'
import SwiperCore from 'swiper'
import { Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'

import ButtonChevron from '@/components/buttons/ButtonChevron.vue'
import BaseLoading from '@/components/general/BaseLoading.vue'
import MixesGridIngredient from '@/components/mix/MixesGridIngredient.vue'
import BrowserService from '@/services/browserService'

SwiperCore.use([Scrollbar])

defineProps({
  kind: {
    type: String,
    default: 'musli',
  },

  ingredients: {
    type: Object,
    default: noop,
  },
})
const mixesSwiper = ref()

const onSwiper = (swiper) => {
  mixesSwiper.value = swiper
  mixesSwiper.value.scrollbar?.updateSize()
}
const onSwiperInit = (swiper) => {
  swiper.scrollbar?.updateSize()
}
</script>
